import * as React from 'react';
import Common from '../plugins/Common';
import { Typography, styled } from '@mui/material';
import { usePaymentContext } from '../context';

const PaymentValue = styled('p')(({ theme }) => ({
    fontSize: '2.7em',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    margin: 0
}));

const PaymentValueIntPart = styled('span')(() => ({
    fontSize: '1.5em',
}));

const DetailValue = styled('span')(({ theme }) => ({
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
}));

type State = {
    amountAsInt: number;
    amountFraction: string;
    address: string;
};

const defaultState: State = {
    amountAsInt: 0,
    amountFraction: '00',
    address: ''
}

export default function PaymentDetails() {

    const [state, setState] = React.useState(defaultState);
    const paymentContext = usePaymentContext();

    React.useEffect(() => {
        if (!paymentContext.paymentRequest) {
            setState(defaultState);
            return;
        }

        const amountAsInt = parseInt(paymentContext.paymentRequest.paymentValue.toString());
        let amountFraction = paymentContext.paymentRequest.paymentValue.toFixed(2);
        amountFraction = amountFraction.substr(amountFraction.length - 2);

        const addressParts =
            [
                paymentContext.billingAddressDetails?.addressLine1,
                paymentContext.billingAddressDetails?.addressLine2,
                paymentContext.billingAddressDetails?.town,
                paymentContext.billingAddressDetails?.county,
                paymentContext.billingAddressDetails?.postCode,
                paymentContext.billingAddressDetails?.country
            ];

        setState(prev => ({
            ...prev,
            amountAsInt,
            amountFraction,
            address: addressParts.filter(p => !Common.isNullOrWhiteSpace(p)).join(', ')
        }));
    }, []);

    return (
        <>
            <Typography variant="h4" gutterBottom>What happens next</Typography>
            <p>Once we have recieved your payment we will be able to process the rest of your claim.</p>
            <p>
                We will send you a confirmation email of this payment and contact you again soon.
                If you believe there has been an error please do not hesistate to contact us.
            </p>

            <Typography variant="h4" gutterBottom>Your payment breakdown</Typography>
            <span>You pay</span>
            <PaymentValue >
                <PaymentValueIntPart>{paymentContext.paymentRequest?.currencySymbol}{state.amountAsInt}.</PaymentValueIntPart>
                {state.amountFraction}
            </PaymentValue>

            {
                (paymentContext.isBillingAddressSet) &&
                <>
                    <p>
                        <span>Your details</span>
                        <br />
                        <DetailValue >{paymentContext.billingAddressDetails?.firstName} {paymentContext.billingAddressDetails?.lastName}</DetailValue>
                    </p>

                    <p>
                        <span>Billing Address</span>
                        <br />
                        <DetailValue >{state.address}</DetailValue>
                    </p>
                </>
            }
        </>
    )
}
